import { orientation } from './tokens.styles';

export const orientationPrefix = (name) =>
    orientation[name] ? `${name}-` : '';

export const percentage = (dividend, divisor) =>
    `${(dividend / divisor) * 100}%`;
